<template>
<div>
<header-component></header-component>
  <div class="container-fluid mt--6">
    <div class="card">
      <div class="card-header">
        <h3 class="mb-0" style="text-transform:capitalize;">Roles List</h3>
        <div class="col-lg-12 col-5 text-right">
          <base-button size="sm" type="primary" @click="createRole">Add New</base-button>
        </div>
      </div>
      <el-table
        class="table-responsive table-flush"
        header-row-class-name="thead-light"
        :data="roleList"
      >
        <el-table-column label="Role Name" min-width="170px" prop="label" sortable></el-table-column>
        <el-table-column min-width="70px">
          <template slot-scope="scope">
            <el-dropdown slot="dropdown" @command="command => handleAction(scope.row, command)">
              <el-button type="primary" size="mini">
                  Actions
                  <i class="el-icon-arrow-down el-icon--right" />
                </el-button>
              <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                <el-dropdown-item command="edit">Edit</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog title="Add Role" :visible.sync="addRole">
      <add-role @close="addRole = false"></add-role>
    </el-dialog>
  </div>
  </div>
</template>
<script>
import {
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Dialog,
  Button
} from "element-ui";
import AddRole from "./AddRole";
import { mapGetters, mapActions, mapMutations } from "vuex";
import headerComponent from "../Components/HeaderComponent";

export default {
  data: () => {
    return {
      addRole: false
    };
  },

  computed: {
    ...mapGetters({
      roleList: "role/getRoles",
      role:"role/getRole"
    })
  },
   
   mounted()  {
      this.getRoles();
   },

  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    "add-role": AddRole,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    "header-component": headerComponent

  },

  methods: {
    ...mapActions({getRoles:'role/getRoles',fetchRole:"role/fetchRole"}),
    ...mapMutations({setRole : "role/setRole",resetRole : "role/resetRole"}),
    
    handleAction(role, command) {
      if (command === "edit") {
        this.fetchRole(role.roleId).then((res) => {
          this.setRole(res);
          this.addRole = true;
        })
        //this.$router.push('/roles/add/'+role.roleId);
      }
    },
    createRole() {
      this.resetRole();
      this.addRole = true;
    },


  }
};
</script>